import RelatorioStrategyBase from "./RelatorioStrategyBase";
import FormLiquidadas from "../filtros/FormLiquidadas";
import moment from "moment";

export default class ContasPagasStrategy extends RelatorioStrategyBase {
  processar(dadosBrutos) {
    const grupos = [];
    let totaisGerais = { bruto: 0, brutoUsd: 0, retencao: 0, retencaoUsd: 0, descontos: 0, descontosUsd: 0, pago: 0, pagoUsd: 0, saldo: 0, saldoUsd: 0, variacao_cambial: 0, variacao_cambialUsd: 0 };

    if (!Array.isArray(dadosBrutos)) {
      return { titulo: "CONTAS PAGAS", grupos, totaisGerais };
    }

    // Como o back-end agora retorna um array plano, precisamos agrupar
    const agrupado = {};
    const por = this.opcoes.por || "porCliente";

    dadosBrutos.forEach((conta) => {
      // Ignora valores zerados
      if (!conta.bruto || parseFloat(conta.bruto) <= 0) return;

      const adapter = {
        vencimento: conta.vencimento || null,
        os: conta.os || "N/A",
        documento: conta.documento || "",
        navio: conta.navio || conta.navio_nome || conta.manual_navio_nome || "N/A",
        bruto: parseFloat(conta.bruto || 0),
        retencao: parseFloat(conta.retencao || 0),
        descontos: parseFloat(conta.descontos || 0),
        pago: parseFloat(conta.pago || 0),
        saldo: parseFloat(conta.saldo || 0),
        moeda: conta.moeda || 5,
        roe: parseFloat(conta.roe || conta.os_roe || 5),
        variacao_cambial: parseFloat(conta.variacao_cambial || 0),
        variacao_cambialUsd: parseFloat(conta.variacao_cambialUsd || 0)
      };

      const linha = this.criarLinhaTabela(adapter);

      const isEnglish = parseInt(this.opcoes.moeda) !== 5 || this.opcoes.mostrarAmbasMoedas;
      let chaveGrupo = isEnglish ? "GROUP" : "GRUPO";
      if (por === "porCliente") {
        chaveGrupo = `${isEnglish ? 'SUPPLIER' : 'FORNECEDOR'}: ${(conta.pessoa_nome || conta.pessoa?.nome || conta.pessoa || "N/A").toUpperCase()}`;
      } else if (por === "porVencimento" || por === "porData") {
        const data = conta.vencimento;
        chaveGrupo = `${isEnglish ? 'DATE' : 'DATA'}: ${moment(data).format("DD/MM/YYYY")}`;
      } else if (por === "porOS") {
        chaveGrupo = `OS: ${conta.os || conta.os_codigo || "N/A"}`;
      } else if (por === "porTaxa") {
        chaveGrupo = `${isEnglish ? 'FEE' : 'TAXA'}: ${conta.nome_taxa || "N/A"}`;
      } else if (por === "porGrupoTaxa") {
        chaveGrupo = `${isEnglish ? 'FEE GROUP' : 'GRUPO DE TAXA'}: ${conta.grupo_taxa || "N/A"}`;
      }

      if (!agrupado[chaveGrupo]) {
        agrupado[chaveGrupo] = {
          nome: chaveGrupo,
          rows: [],
          totais: { bruto: 0, brutoUsd: 0, retencao: 0, retencaoUsd: 0, descontos: 0, descontosUsd: 0, pago: 0, pagoUsd: 0, saldo: 0, saldoUsd: 0, variacao_cambial: 0, variacao_cambialUsd: 0 }
        };
      }

      agrupado[chaveGrupo].rows.push(linha);
      agrupado[chaveGrupo].totais.bruto += linha.bruto; agrupado[chaveGrupo].totais.brutoUsd += (linha.brutoUsd || 0);
      agrupado[chaveGrupo].totais.retencao += linha.retencao; agrupado[chaveGrupo].totais.retencaoUsd += (linha.retencaoUsd || 0);
      agrupado[chaveGrupo].totais.descontos += linha.descontos; agrupado[chaveGrupo].totais.descontosUsd += (linha.descontosUsd || 0);
      agrupado[chaveGrupo].totais.pago += linha.pago; agrupado[chaveGrupo].totais.pagoUsd += (linha.pagoUsd || 0);
      agrupado[chaveGrupo].totais.saldo += linha.saldo; agrupado[chaveGrupo].totais.saldoUsd += (linha.saldoUsd || 0);
      agrupado[chaveGrupo].totais.variacao_cambial += linha.variacao_cambial; agrupado[chaveGrupo].totais.variacao_cambialUsd += (linha.variacao_cambialUsd || 0);

      totaisGerais.bruto += linha.bruto; totaisGerais.brutoUsd += (linha.brutoUsd || 0);
      totaisGerais.retencao += linha.retencao; totaisGerais.retencaoUsd += (linha.retencaoUsd || 0);
      totaisGerais.descontos += linha.descontos; totaisGerais.descontosUsd += (linha.descontosUsd || 0);
      totaisGerais.pago += linha.pago; totaisGerais.pagoUsd += (linha.pagoUsd || 0);
      totaisGerais.saldo += linha.saldo; totaisGerais.saldoUsd += (linha.saldoUsd || 0);
      totaisGerais.variacao_cambial += linha.variacao_cambial; totaisGerais.variacao_cambialUsd += (linha.variacao_cambialUsd || 0);
    });

    Object.values(agrupado).forEach((grupo) => {
      grupos.push(grupo);
    });

    return {
      titulo: "CONTAS PAGAS",
      grupos,
      totaisGerais,
    };
  }

  getFormComponent() {
    return FormLiquidadas;
  }

}